exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Vi4xF0_Bq2r-Uo90aVbZS{background:#b3b3b3;font-family:menlo, monospace;padding:20px;font-size:14px;position:relative}\n", ""]);

// Exports
exports.locals = {
	"JSONBlock": "_2Vi4xF0_Bq2r-Uo90aVbZS"
};